<template>
  	<div class="stores"  style="height:100%">
    	<div class="breadcrumb">报表 > 用户报表</div>
	    <div class="searchBtn" style="border:none;display:flex">
	      	<el-select v-model="sortBy" placeholder="请选择筛选条件" @change="sortByselect">
			    <el-option
			      	v-for="item in options"
			      	:key="item.value"
			      	:label="item.label"
			      	:value="item.value">
			    </el-option>
			  </el-select>

	    </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row  >
			        <el-table-column prop="userName" label="账号" width="120"></el-table-column>
			        <el-table-column prop="nickname"  label="昵称" width="120"></el-table-column>
			        <el-table-column prop="mobile"  label="电话号" width="120"></el-table-column>
			        <el-table-column prop="vipNo"  label="会员号" width="160"></el-table-column>
			        <el-table-column prop="exchangeStatus"  label="会员券兑换" width="100">
			        	<template slot-scope="scope">{{ scope.row.exchangeStatus=='Y'?'已兑换':'未兑换'}}</template>
			        </el-table-column>
			        <el-table-column prop="duration" label="会员期限">
			        	<template slot-scope="scope" v-if="scope.row.durationType">{{ scope.row.durationType==1?scope.row.duration+'天': scope.row.duration+'月'}}</template>
			        </el-table-column>
			        <el-table-column prop="calorie" label="总卡路里" width="120"></el-table-column>
			        <el-table-column prop="sportCounts"  label="总运动次数" width="100"></el-table-column>
			        <el-table-column prop="validCreateTime" :formatter="this.global.dateFormat" label="会员券兑换日期" width="190"></el-table-column>
			        <el-table-column prop="validStartTime" :formatter="this.global.dateFormat" label="会员券开始日期" width="190"></el-table-column>
			        <el-table-column prop="validEndTime" :formatter="this.global.dateFormat" label="会员券结束日期" width="190"></el-table-column>
			        <el-table-column prop="validExchangeStartTime" :formatter="this.global.dateFormat" label="会员券兑换开始日期" width="190"></el-table-column>
			        <el-table-column prop="validExchangeEndTime" :formatter="this.global.dateFormat" label="会员券兑换结束日期" width="170"></el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" :page-sizes="[10, 30, 100, 500]" layout="total, sizes, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>
	    
	    

  	</div>
</template>  
<script>
export default {
  	mounted() {
    	this.init()
  	},
  	data() {
    	return {
    		userId:'',
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
      		tableData: [], //初始化表格
      		pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		options: [{
	          	value: 1,
	          	label: '会员兑换与否'
	        }, {
	          	value: 2,
	          	label: '会员券兑换日期'
	        }, {
	          	value: 3,
	          	label: '会员券结束日期'
	        }, {
	          	value: 4,
	          	label: '会员期限'
	        }, {
	          	value: 5,
	          	label: '卡路里'
	        }, {
	          	value: 6,
	          	label: '总运动次数'
	        }],
	        sortBy:''
	    };
  	},


  	methods: {
	    //初始化表格数据
    	init() {
	      	var params = {
	        	pageNum: this.pageNum,
	        	limit: this.limit,
	        	sortBy:this.sortBy
	      	};
      		this.$get("/report/getExchangeCodeReport", params)
        	.then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
        	})
    	},
	  	search_mine(){
	  		this.pageNum=1;
	  		this.init();
	  	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.init();
	    },
	    handleSizeChange(val){
	    	this.limit=val;
	    	this.pageNum = 1;
	      	this.init();
	    },
	    sortByselect(val){
	    	this.sortBy=val;
	    	this.pageNum = 1;
	      	this.init();
	    }    
  	}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/report/index.vue